//Msg service
import { http, httpFile } from './http_service';
// Get all meg according to quote id
export function all(quoteId){
    return http().get(`/msg/all/${quoteId}`)
}
// Get Single message
export function single(id){
    return http().get(`/msg/single/${id}`)
}
export function add(data){
    return http().post(`/msg/add`, data)
}
export function update(id, data){
    return http().put(`/msg/update/${id}`, data)
}
 /**
 * Update mesg status whether read or not, this will change status of messageStatus of client_vehicle_details
 * 1,2 or 3
 */
// export function updateMsgStatus(id, data){
//     return http().put(`/msg/update-msg-status/${id}`, data)
// }

/**
 * Update Read msg status whether read or not, this will change number of message in client_vehicle_details
 * $id - messages record id
 * reader - might be vsa or other
 * status would be 0 or 1, if they read status going to be 0 else 1
 */
export function updateMsgReadStatus(id, data){
    return http().put(`/msg/update-msg-read-status/${id}`, data)
}


/**
 * Get new messages whether to be read,
 * @param data - if it is dealer, dealer user id (dealerUserId) or if blank it is Admin (whole data), reader should be vsa or other
 * 
 * data = {
 *          "dealerUserId":'',
 *          "reader":"vsa"
 *      }
 * 
 */
export function getNewMsgs(data){
    return http().get(`/msg/get-new-msgs`, { params: data })
}


/**
 * Update Read msg sender_party whether read or not, this will change number of message in client_vehicle_details
 * @param id - messages record id
 * @param reader - might be vsa or other
 * @param sender_party - would be 0 or 1, if they read sender_party going to be 0 else 1
 */
export async function fnUpdateMsgReadStatus(id, reader, sender_party) {
    this.errors = ''
    let obj = {
        reader: reader,
        sender_party: sender_party
    }
    try {
        const res = await updateMsgReadStatus(id, obj)
    } catch (error) {
        console.log('updateMsgReadStatus', error)
    }
}





